<template>
  <div class="spaceAround home-banner">
    <img class="home-logo" src="../../../assets/logo/logo.png" @click="gowww()" />
    <menu-nav />
    <img class="home-logo is-phone" src="../../../assets/logo/logo.png" @click="gowww()" />
    <!-- <el-dropdown v-if="account"> -->
    <div v-if="account">
      <el-button class="mm-button" style="display: flex;justify-content: center;align-items: center;"
        @click="handleClose">
        <img src="@/assets/image/transfer/eth.png" v-if="fromType1 == 'Ethereum'"
          style="width: .24rem;height: .24rem;margin-right: .1rem;" />
        <img v-if="fromType1 == 'Treasurenet'" src="@/assets/image/exchange/unit.png"
          style="width: .24rem;height: .24rem;margin-right: .1rem;" />
        <Account :value="account"></Account>
      </el-button>
    </div>
    <!--      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <span @click="handleClose">Log out</span>
        </el-dropdown-item>
      </el-dropdown-menu>-->
    <!-- </el-dropdown> -->
    <el-button v-else class="mm-button" @click="connectMetaMask" :loading="loading" :disabled="isConnect">
      <!-- <img class="mm-logo" src="../../../assets/logo/mm-logo.png" /> -->
      <span class="mm-text" id="metaMask_connectButton">{{ btnText }}</span>
    </el-button>
  </div>
</template>

<script>
import MetaMaskOnboarding from "@metamask/onboarding";
import menuNav from "./nav.vue";
import metaMask from "./metaMask.js";
import Web3 from "web3";
import {
  getContractGovernance,
  getContractDao,
  getContractBid,
  getContractTAT,
  getContractUnitPrice,
  getContractUSTN,
  getContractUSTNFinance,
  getAbi
} from "@/api/contract.js";
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";

export default {
  data() {
    return {
      isInstall: true,
      isConnect: false,
      btnText: "Connect MetaMask",
      loading: false,
      isLog: true,
      account: undefined,
      chainId: undefined,
      fromType1: "Treasurenet",
      // aList: [
      //   {
      //     // VUE_APP_ETH_NAME
      //     // id: "0x5",
      //     // rpcUrls: "https://119.3.221.120:30017",
      //     // rpcUrls: "https://www.treasurenet.io:30017",
      //     // rpcUrls: "https://goerli.infura.io/v3/",
      //     type: "Treasurenet",
      //     name: process.env.VUE_APP_Gl_NAME.toLocaleLowerCase(),
      //     id: process.env.VUE_APP_GLINID.toLocaleLowerCase(),
      //     rpcUrls: process.env.VUE_APP_GL_RPC_URLS.toLocaleLowerCase(),
      //     nativeCurrency: { name: "UNIT", symbol: "UNIT", decimals: 18 }
      //   },
      //   {
      //     // name: "treasurenet stage",
      //     // rpcUrls: "https://124.70.23.119:3017",
      //     // rpcUrls: "https://124.70.23.119:8555",
      //     type: "Ethereum",
      //     name: process.env.VUE_APP_CHAIN_NAME.toLocaleLowerCase(),
      //     id: process.env.VUE_APP_CHAINID.toLocaleLowerCase(),
      //     rpcUrls: JSON.parse(process.env.VUE_APP_RPC_URLS),
      //     nativeCurrency: { name: "UNIT", symbol: "UNIT", decimals: 18 }
      //   }
      // ]
      aList: [
        {
          type: "Treasurenet",
          name: process.env.VUE_APP_TN_CHAIN_NAME.toLowerCase(),
          id: process.env.VUE_APP_TN_CHAINID.toLowerCase(),
          // rpcUrls: process.env.VUE_APP_TN_RPC_URLS.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_TN_RPC_URLS),
          nativeCurrency: {
            name: "UNIT",
            symbol: "UNIT",
            decimals: 18
          }
        },
        {
          type: "Ethereum",
          name: process.env.VUE_APP_ETH_NAME.toLowerCase(),
          id: process.env.VUE_APP_ETH_CHAINID.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_ETH_RPC_URLS),
          nativeCurrency: {
            name: "UNIT",
            symbol: "UNIT",
            decimals: 18
          }
        }
      ],
    };
  },
  components: {
    menuNav
  },
  computed: {
    currentNetwork() {
      return this.$store.state.app.currentNetwork;
    }
  },
  watch: {
    "$store.getters.metaMaskObj.account": {
      handler(newValue, oldValue) {
        this.account = newValue;
        if (newValue) {
          this.getCurr();
        }
      },
      deep: true,
      immediate: true
    },
    // currentNetwork: {
    //   handler(newNetwork) {
    //     if (this.account) {
    //       this.checkAndSwitchNetwork();
    //     }
    //   },
    //   immediate: true
    // }
  },
  mounted() {
    this.init().then(res => {
      // console.log('this.isInstallinited', this.isInstall)
      this.$store.commit("app/SET_MATEMASK", { initOk: true });
      ethereum.autoRefreshOnNetworkChange = false;
      //监听钱包切换
      let that = this;
      ethereum.on("accountsChanged", function (accounts) {
        that.closeSuccess();
      });
      // that.getCurr();
      //监听链网络改变
      ethereum.on("chainChanged", async () => {
        await this.getChainId();
        if (
          process.env.VUE_APP_TN_CHAINID.toLocaleLowerCase() !=
          this.chainId.toLocaleLowerCase() &&
          !that.$store.getters.metaMaskObj.stopRefreshJoinNet
        ) {
          that.closeSuccess();
        }
      });
    });
  },
  methods: {
    async gowww() {
      window.open(process.env.VUE_APP_TREASURE_NET_WEBSITE, "_self");
    },
    async init() {
      await this.initContract();

      return new Promise(async resolve => {
        this.isInstall = metaMask.isMetaMaskInstalled();
        this.$store.commit("app/SET_MATEMASK", { isInstall: this.isInstall });

        if (this.isInstall) {
          console.log('this.getToken', getToken())
          if (getToken()) {
            try {
              // 检查 MetaMask 是否真的连接了
              const accounts = await ethereum.request({ method: "eth_accounts" });
              const storedAccount = getToken();
              
              // 验证存储的 account 是否在当前连接的账户中
              if (accounts.length > 0 && accounts.includes(storedAccount)) {
                this.account = storedAccount;
                this.$store.commit("app/SET_MATEMASK", {
                  isConnect: true,
                  account: storedAccount
                });

                // 初始化时检查当前网络
                this.checkAndSwitchNetwork();
              } else {
                // token 存在但 MetaMask 没有连接或账户不匹配，清除 token
                removeToken();
                this.btnText = "Connect MetaMask";
                this.$store.commit("app/SET_MATEMASK", {
                  isConnect: false,
                  account: ""
                });
              }
            } catch (error) {
              // 无法获取账户信息，清除 token
              console.error('Failed to get accounts:', error);
              removeToken();
              this.btnText = "Connect MetaMask";
              this.$store.commit("app/SET_MATEMASK", {
                isConnect: false,
                account: ""
              });
            }
          } else {
            this.btnText = "Connect MetaMask";
          }
        } else {
          this.btnText = "Install MetaMask";
        }
        resolve();
      });
    },

    async getCurr() {
      let web3 = new Web3(window.ethereum);
      let res = await ethereum.request({ method: "eth_chainId" });
      let chainId = res;
      const decimalChainId = parseInt(chainId, 16);
      // console.log('decimalChainId', decimalChainId);
      let currType = this.aList.filter(item => item.id == decimalChainId);
      // lof
      // console.log('currType', currType)
      if (currType.length != 0) {
        this.fromType1 = currType[0].type;
      }
    },
    async connectMetaMask() {
      if (!this.isInstall) {
        this.loading = true;
        this.btnText = "Onboarding in progress";
        const onboarding = new MetaMaskOnboarding();
        onboarding.startOnboarding();
      } else {
        console.log('currentNetwork', this.currentNetwork)
        this.loading = true;
        this.btnText = "Connect MetaMask";
        // 获取目标网络配置
        const targetNetwork = this.aList.find(item =>
          item.type === this.currentNetwork
        );

        if (targetNetwork) {
          const chainId = '0x' + Number(targetNetwork.id).toString(16);
          try {
            // 尝试切换到目标网络
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId }]
            });
          } catch (err) {
            if (err.code === 4902) {
              // 如果网络不存在,则添加网络
              let params = [{
                chainId,
                chainName: targetNetwork.name,
                rpcUrls: Array.isArray(targetNetwork.rpcUrls) ? targetNetwork.rpcUrls : [targetNetwork.rpcUrls],
                nativeCurrency: targetNetwork.nativeCurrency
              }]
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: params
              });
            }
          }
        }

        await this.onClickConnect();
        this.loading = false;
      }
    },
    async onClickConnect() {
      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
        } else {
          this.account = accounts[0];
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: accounts[0]
          });
          console.log('this.account', this.account)
          setToken(this.account);
          // window.location.reload();
        }
      } catch (error) {
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isConnect: false });
      }
    },
    async joinNet() {
      try {
        await ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: process.env.VUE_APP_TN_CHAINID, //死的 可以写到配置文件里面
              chainName: process.env.VUE_APP_TN_CHAIN_NAME, // 就是一个名字随便起
              rpcUrls: JSON.parse(process.env.VUE_APP_TN_RPC_URLS),
              nativeCurrency: {
                name: "UNIT",
                symbol: "UNIT", // 2-6 characters long
                decimals: 18
              }
            }
          ]
        });
        // console.log("joinNet ok===");
        this.$store.commit("app/SET_MATEMASK", { isJoinNet: true });
      } catch (error) {
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isJoinNet: false });
        // console.log(error);
      }
    },
    async initContract() {
      try {
        const res1 = await getAbi("Governance");
        const res2 = await getAbi("Oracle");
        const res3 = await getAbi("TCashLoan");
        const tCashAuctionRes = await getAbi("TCashAuction");
        // const res4 = await getAbi("USTNFinance");
        const res5 = await getAbi("ParameterInfo");
        const res6 = await getAbi("Bid");
        const res7 = await getAbi("TAT");
        const res8 = await getAbi("DAO");
        const res9 = await getAbi("TCash");
        this.setContract(res1, "contractGovernance");
        this.setContract(res2, "contractOracle");
        this.setContract(res3, "contractTCashLoan");
        // this.setContract(res4, "contractUSTNFinance");
        this.setContract(res5, "contractParameterInfo");
        this.setContract(res6, "contractBid");
        this.setContract(res7, "contractTAT");
        this.setContract(res8, "contractDao");
        this.setContract(res9, "contractTCash");
        this.setContract(tCashAuctionRes, "contractTCashAuction");
        // console.log("contract ok");
      } catch (e) {
        // console.log(e);
      }
    },
    setContract(res, key) {
      let resData = res.data;
      let contract = new web3.eth.Contract(resData.abi, resData.address);
      let add = resData.address;
      this.$store.commit("app/SET_CONTRACTMAP", {
        key: key,
        value: {
          contract: contract,
          address: add
        }
      });
    },

    async changeNetwork(val) {
      // 如果val是0x开头的十六进制,转换为十进制
      if (typeof val === 'string' && val.startsWith('0x')) {
        val = parseInt(val, 16).toString();
      }
      // console.log(val);
      let obj = this.aList.filter(item => item.id == val);
      if (obj.length != 0) {
        if (obj[0].type === this.currentNetwork) {
          this.onClickConnect();
          return
        }
        await window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [
              {
                chainId: '0x' + Number(obj[0].id).toString(16)
              }
            ]
          })
          .then(res => {
            // console.log(res);
            res;
            this.onClickConnect();
          })
          .catch(err => {
            // console.log("44", err);
            if (err.code === 4902) {
              this.joinNet();
              // 用户在申请连接时既没有取消也没有同意钱包的绑定需要手动打开小狐狸钱包的插件进行绑定
            }
            if (err.code == 4001) {
              // console.log("用户拒绝连接");
            }
          });
      } else {
        let res = await window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [
              {
                chainId: '0x' + Number(val).toString(16)
              }
            ]
          })
          .then(res => {
            // console.log(res);
            res;
            // this.onClickConnect();
          })
          .catch(err => {
            // console.log("44", err);
            if (err.code === 4902) {
              this.joinNet();
              // 用户在申请连接时既没有取消也没有同意钱包的绑定需要手动打开小狐狸钱包的插件进行绑定
            }
            if (err.code == 4001) {
              // console.log("用户拒绝连接");
            }
          });
      }
    },
    async getChainId() {
      let res = await ethereum.request({ method: "eth_chainId" });
      this.chainId = res;
      if (this.chainId) {
        // console.log(this.chainId);
        this.changeNetwork(this.chainId);
      }
    },
    handleClose() {
      this.$confirm("Are you sure you want to disconnect?", "Exit", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        this.closeSuccess();
        this.$message.success("successfully!");
      });
    },
    closeSuccess() {
      removeToken();
      this.$store.commit("app/SET_MATEMASK", {
        isConnect: false,
        account: ""
      });
      this.account = undefined;
      // window.location.reload();
    },
    log(msg) {
      if (this.isLog) {
        // console.log("msg", msg);
      }
    },
    // 新增方法:检查并切换网络
    async checkAndSwitchNetwork() {
      const chainId = await ethereum.request({ method: 'eth_chainId' });
      const currentChainNetwork = this.aList.find(item => item.id === chainId);
      if (!currentChainNetwork || currentChainNetwork.type !== this.currentNetwork) {
        const targetNetwork = this.aList.find(item =>
          item.type === this.currentNetwork
        );
        if (targetNetwork) {
          await this.changeNetwork(targetNetwork.id);
        }
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.home-banner {
  padding: 0.24rem 0;
  // background: rgba(255, 255, 255, 0.1);
  position: absolute;
  left: 0;
  right: 0;
  z-index: 100;

  .home-logo {
    width: 2.41rem;
    cursor: pointer;
  }

  .mm-button {
    // padding: 0.18rem 0.24rem;
    // border: 1px solid #d71718;
    width: 2.4rem;
    height: 0.48rem;
    border-radius: 0.14rem;
    font-size: 0.18rem;
    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
    cursor: pointer;
    color: #ffffff;
    border: 0;

    &:hover {
      background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
      color: #ffffff;
    }

    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // &.el-button.is-disabled,
    // .el-button.is-disabled:hover,
    // .el-button.is-disabled:focus {
    //   background: transparent;
    //   border: 1px solid #d71718;
    // }

    .mm-logo {
      height: 0.26rem;
      margin-right: 0.05rem;
      position: relative;
      top: 0.03rem;
    }

    .mm-text {
      position: relative;
      top: -0.01rem;
    }
  }
}

.home-logo.is-phone {
  display: none;
}

@media screen and (max-width: 800px) {
  .home-logo {
    display: none;
  }

  .home-logo.is-phone {
    display: block;
  }
}
</style>
